import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import type { SavedOrder } from "../orderTypes";
import type { Dayjs } from "dayjs";

export function getAdvancePaymentDefaultDeadline(order: Pick<SavedOrder, "start">, now: () => Dayjs = dayjs) {
  const orderStart = order.start ? dayjs(order.start, ISO_DATE_FORMAT) : null;
  const in30Days = now().add(30, "days");
  if (orderStart === null) {
    return in30Days.format(ISO_DATE_FORMAT);
  }
  if (in30Days.isAfter(orderStart.subtract(68, "days")) && in30Days.isBefore(orderStart.subtract(30, "days"))) {
    return orderStart.subtract(65, "days").format(ISO_DATE_FORMAT);
  }
  if (!in30Days.isBefore(orderStart.subtract(30, "days"))) {
    return now().add(3, "days").format(ISO_DATE_FORMAT);
  }
  return in30Days.format(ISO_DATE_FORMAT);
}
